module.exports = __webpack_public_path__ + "images/assets/5982a84d06b911dedcf1c472accd0994.svg";